// extracted by mini-css-extract-plugin
export default {"modalHeader":"styles_modalHeader__RBwvG"};